import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

export const ThankYouStyledSocialButton = styled.a`
    display: block;
    width: 32px;
    height: 32px;
    margin: 0 8px;

    &:first-child {
        margin-left: 0;
    }
    &:last-child {
        margin-right: 0;
    }
    @media ${respondAbove.xl} {
        width: 40px;
        height: 40px;
        margin: 0 16px;

        &:first-child {
            margin-left: 0;
        }
        &:last-child {
            margin-right: 0;
        }
    }
`
